// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dashboard.listaDescargaBlock.title': 'Lista de Descarga',
    'dashboard.listaDescargaBlock.searchStatus': 'Buscar status…',
    'dashboard.listaDescargaBlock.pair': 'Dupla',
    'dashboard.listaDescargaBlock.searchPair': 'Buscar dupla…',
    'dashboard.listaDescargaBlock.location': 'Local',
    'dashboard.listaDescargaBlock.searchLocation': 'Buscar local…',
    'dashboard.listaDescargaBlock.clear': 'Limpar',
    'dashboard.listaDescargaBlock.retry': 'Tentar de novo',
    'dashboard.listaDescargaBlock.emptyFiltered': 'Nenhum conjunto para os filtros.',
    'dashboard.listaDescargaBlock.emptyToday': 'Painel vazio hoje.',
    'dashboard.listaDescargaBlock.sets': '{{count}} conjuntos',
    'dashboard.listaDescargaBlock.moreOne': 'outro',
    'dashboard.listaDescargaBlock.moreOther': 'outros',
  },
  en: {
    'dashboard.listaDescargaBlock.title': 'Unloading List',
    'dashboard.listaDescargaBlock.searchStatus': 'Search status…',
    'dashboard.listaDescargaBlock.pair': 'Pair',
    'dashboard.listaDescargaBlock.searchPair': 'Search pair…',
    'dashboard.listaDescargaBlock.location': 'Location',
    'dashboard.listaDescargaBlock.searchLocation': 'Search location…',
    'dashboard.listaDescargaBlock.clear': 'Clear',
    'dashboard.listaDescargaBlock.retry': 'Try again',
    'dashboard.listaDescargaBlock.emptyFiltered': 'No sets for the filters.',
    'dashboard.listaDescargaBlock.emptyToday': 'Panel empty today.',
    'dashboard.listaDescargaBlock.sets': '{{count}} sets',
    'dashboard.listaDescargaBlock.moreOne': 'other',
    'dashboard.listaDescargaBlock.moreOther': 'others',
  },
  es: {
    'dashboard.listaDescargaBlock.title': 'Lista de descarga',
    'dashboard.listaDescargaBlock.searchStatus': 'Buscar estado…',
    'dashboard.listaDescargaBlock.pair': 'Pareja',
    'dashboard.listaDescargaBlock.searchPair': 'Buscar pareja…',
    'dashboard.listaDescargaBlock.location': 'Lugar',
    'dashboard.listaDescargaBlock.searchLocation': 'Buscar lugar…',
    'dashboard.listaDescargaBlock.clear': 'Limpiar',
    'dashboard.listaDescargaBlock.retry': 'Intentar de nuevo',
    'dashboard.listaDescargaBlock.emptyFiltered': 'Ningún conjunto para los filtros.',
    'dashboard.listaDescargaBlock.emptyToday': 'Panel vacío hoy.',
    'dashboard.listaDescargaBlock.sets': '{{count}} conjuntos',
    'dashboard.listaDescargaBlock.moreOne': 'otro',
    'dashboard.listaDescargaBlock.moreOther': 'otros',
  },
}
